import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import OrderType from "../../../ItemGrid/OrderType";
import { ROUTE_MENU } from "../../../../constants";
import { IItemPathToRoute } from "../../../../models/item.model";

const LocationModal: React.FC<{
  showModal: boolean;
  setShowModal: (value: boolean) => void;
  itemPath?: IItemPathToRoute;
  isRedirectNeeded?: boolean;
}> = ({ showModal, setShowModal,itemPath, isRedirectNeeded= true }) => {
  const closeOpenOrderModal = () => {
    setShowModal(false);
  };
  let path = itemPath ?? {
    pathname: ROUTE_MENU,
    state: {},
    search: "",
  }
  return (
    <Modal
      show={showModal}
      centered
      className="theme-modal-style app_container_wrap  border-radius-15 px-5 order_type_modal"
      onHide={closeOpenOrderModal}
    >
      <Modal.Header className="x-4 justify-content-center">
        <button
          type="button"
          className="btn modal-close-button pe-0"
          onClick={closeOpenOrderModal}
        >
          Close
        </button>
      </Modal.Header>
      <Modal.Body>
        <OrderType handleOrderTypeModal={closeOpenOrderModal} itemPath={isRedirectNeeded ? path : null} />
      </Modal.Body>
    </Modal>
  );
};

export default LocationModal;
